// extracted by mini-css-extract-plugin
export default {"resultsPage":"ResultsPage_resultsPage__gVstd"};